import { render, staticRenderFns } from "./UserEditTabContent.vue?vue&type=template&id=d823071c&"
import script from "./UserEditTabContent.vue?vue&type=script&lang=js&"
export * from "./UserEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports